<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.school_name }}
        </template>
      </el-table-column>

      <el-table-column label="小格使用次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.smallCount }}
        </template>
      </el-table-column>

      <el-table-column label="大格使用次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.largeCount }}
        </template>
      </el-table-column>

      <el-table-column label="总使用次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.allCount }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          start_date: "",
          end_date: "",
        },
        btnLoading: false,
        dateArr: null,
      };
    },
    created() {
      this.listQuery.start_date = moment().format("YYYY-MM-DD");
      this.listQuery.end_date = moment().format("YYYY-MM-DD");
      this.dateArr = [this.listQuery.start_date, this.listQuery.end_date];
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
      },
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_date = newVal[0];
          this.listQuery.end_date = newVal[1];
        } else {
          this.listQuery.start_date = "";
          this.listQuery.end_date = "";
        }
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/takeoutSideboardOrder/schoolCount",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      handleDetail(row) {
        this.$router.push("/sideboard/takeoutSideboardOrderDeviceCount?school_id=" + row.id + "&start_date=" + this.listQuery.start_date + "&end_date=" + this.listQuery.end_date)
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
